// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2471":"css/admin-app.7024","5523":"css/app.7024"}[chunkId] + ".css";
};